import {getLocalBotLeagueId} from '../../configs/localBotLeagues';
import {getVisibleBotIconPath} from './getVisibleBotIconPath';
import {AI_ICON_PATH} from '../../configs/aiMatch';

/**
 * Иконка значка бота: у «явного» бота рейтингового матча — по его лиге, у бота
 * локальной партии — по выбранному для него бонусу, у ИИ-игрока промо-матча —
 * своя иконка ИИ (проверяется первой: лиги и бонуса у него нет, а иконка бота
 * выдала бы его за бота).
 *
 * Иконки названы по лигам, а у локального бота лиги нет: берется
 * лига-эквивалент его бонуса (см. configs/localBotLeagues). По ней же он
 * получает прибавку к росту отрядов (см. configs/botLeagueSupplyGrowth) —
 * значок честно показывает силу бота. В состояние игрока эта лига не пишется:
 * по полю leagueId работает давление ботов на игрока (applyBotPressureLatches).
 *
 * @param {Object} player
 * @param {boolean} [isBlackOutline] - вариант с черным контуром, для светлых плашек.
 *   У иконки ИИ такого варианта пока нет — на светлых плашках та же иконка
 */
export const getBotMarkIconPath = (player, isBlackOutline = false) => {
  if (player?.isAi) {
    return AI_ICON_PATH;
  }
  return player?.isVisibleBot
    ? getVisibleBotIconPath(player.leagueId, isBlackOutline)
    : getVisibleBotIconPath(getLocalBotLeagueId(player?.bonus), isBlackOutline);
};
